/* eslint-disable max-len */

import PropTypes from 'prop-types'

import { idPropType } from '../common/id-prop-type'
import { iso8601PropType } from '../common/iso-8601-prop-type'
import { locationDescriptionPropType } from '../common/location-description-prop-type'
import { positionPropType } from '../common/position-prop-type'
import { tripModePropType } from '../trip/trip-mode-prop-type'
import { accelerationEventTypePropType } from './acceleration-event-type-prop-type'

/**
 * @typedef {Object} AccelerationEvent
 * @property {Id} 					    accelerationEventId		- The id of the acceleration event.
 * @property {AccelerationEventTypes}   accelerationEventType	- The acceleration event type.
 * @property {number}				    avgAcceleration			- The average acceleration of the object during the acceleration event (in milli-g).
 * @property {Id} 					    driverId 				- The ID of the driver.
 * @property {number}				    endSpeed		   		- The speed at the end of the driving event (in kph).
 * @property {ISO8601} 				    endTime					- The end time of the acceleration event (ISO8601).
 * @property {boolean} 				    inCity					- The location description (in city = true / countryside = false).
 * @property {number} 				    maxAcceleration			- The maximum acceleration of the object during the acceleration event (in milli-g).
 * @property {Id} 					    objectId				- The ID of the object.
 * @property {Position} 			    position				- The position information about acceleration event, including longitude and latitude.
 * @property {number} 				    roadSpeedLimit			- The road speed limit at the position of the object (in kph).
 * @property {TripModes} 			    tripMode 				- The trip mode type of acceleration event.
 * @property {number} 				    severityLevel			- The severity level of acceleration event, range from 10 to 50.
 * @property {number}				    speedAtMaxAcceleration	- The speed at the moment of the max acceleration affecting the vehicle during the driving event (in kph).
 * @property {number}				    startSpeed		   		- The speed at the begining of the driving event (in kph).
 * @property {ISO8601} 				    startTime				- The start time of the acceleration event (ISO8601).
 * @property {LocationDescription} 	    locationDescription		- The parameters of acceleration event location description.
 */

const accelerationEventType = {
    accelerationEventId: idPropType,
    accelerationEventType: accelerationEventTypePropType,
    avgAcceleration: PropTypes.number,
    driverId: idPropType,
    endSpeed: PropTypes.number,
    endTime: iso8601PropType,
    inCity: PropTypes.bool,
    locationDescription: locationDescriptionPropType,
    maxAcceleration: PropTypes.number,
    objectId: idPropType,
    position: positionPropType,
    roadSpeedLimit: PropTypes.number,
    severityLevel: PropTypes.number,
    speedAtMaxAcceleration: PropTypes.number,
    startSpeed: PropTypes.number,
    startTime: iso8601PropType,
    tripMode: tripModePropType
}
Object.freeze(accelerationEventType)

const accelerationEventPropType = PropTypes.shape(accelerationEventType)

export { accelerationEventType, accelerationEventPropType }
